import { PlansAndPurchaseTabBaseDataProvider } from './PlansAndPurchaseTabBaseDataProvider';
import {
  GetExtendSeatsPriceFunction,
  GetExtendSeatsUrlFunction,
  GetPlansAndPurchaseDataResponse,
  GetRenewalUrlFunction,
} from '../types/types';

export class PlansAndPurchaseTabGzDataProvider extends PlansAndPurchaseTabBaseDataProvider {
  public async getPlansAndPurchaseData(): Promise<GetPlansAndPurchaseDataResponse> {
    return await this.dependencies.api.clients.PlansAndPurchase.GetPlansAndPurchaseData().toPromise();
  }

  public async getExtendSeatsPrice(licenseKey: string, seatsCount: number): ReturnType<GetExtendSeatsPriceFunction> {
    return await this.dependencies.api.clients.PlansAndPurchase.GetExtendSeatsPrice(licenseKey, seatsCount).toPromise();
  }

  public async getExtendSeatsUrl(licenseKey: string, seatsCount: number): ReturnType<GetExtendSeatsUrlFunction> {
    return await this.dependencies.api.clients.PlansAndPurchase.GetExtendSeatsUrl(licenseKey, seatsCount).toPromise();
  }

  public async getRenewalUrl(licenseKey: string): ReturnType<GetRenewalUrlFunction> {
    return await this.dependencies.api.clients.PlansAndPurchase.GetRenewalUrl(licenseKey).toPromise();
  }
}
